import { render } from "./MenuArrow.vue?vue&type=template&id=60798530"
import script from "./MenuArrow.vue?vue&type=script&lang=js"
export * from "./MenuArrow.vue?vue&type=script&lang=js"

import "./MenuArrow.vue?vue&type=style&index=0&id=60798530&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__